import {createContext, PropsWithChildren, useContext, useMemo, useState} from "react";
import {DialogContent, DialogTitle} from "@mui/material";
import {SmoothActionBar} from "./SmoothActionBar";
import {Dialog2} from "./Dialog2";

export const ConfirmContext = createContext({
    confirm: (message: any) => Promise.resolve(true),
})

export function useConfirm() {
    return useContext(ConfirmContext);
}

export function ConfirmationProvider(props: PropsWithChildren<{}>) {

    const [message, setMessage] = useState<any|null>(null);
    const [callback, setCallback] = useState({
        resolve: (tf: boolean) => {},
        reject: (tf: Error) => {},
    })

    const ctx = useMemo(() => ({
        confirm: (input: any) => {
            return new Promise<boolean>((resolve, reject) => {
                setMessage(input);
                setCallback({
                    resolve: resolve,
                    reject: reject
                });
            });
        }
    }), []);

    const cancel = () => {
        setMessage(null);
        callback.reject(new Error("false"))
    };

    const submit = () => {
        setMessage(null);
        callback.resolve(true)
    }

    return (
        <ConfirmContext.Provider value={ctx}>
            <Dialog2 open={message !== null} onClose={cancel} onEnterPress={submit}>
                <DialogTitle>Confirm</DialogTitle>
                <DialogContent>
                    {message}
                </DialogContent>
                <SmoothActionBar
                    onCancel={cancel}
                    onSubmit={submit}
                    actionName="Confirm"
                />
            </Dialog2>
            {props.children}
        </ConfirmContext.Provider>
    )
}